<template>
	<canvas class="rive-element-animation rive-element-animation-fit" :id="this.canvasId"></canvas>
</template>

<script>

import { Rive, Layout, Fit, Alignment } from '@rive-app/canvas';
import axios from "axios";
import * as rive from "@rive-app/canvas";

export default {
	components: {},
	props: {
		id: String,
	},
	data() {
		return {
			riveUrl: "",
			canvasId: "",
		};
	},
	created() {
		// console.log('this.id: ', this.id)
		axios.get(`/umbraco/api/FeaturedAnimationApi/GetById/${this.id}`).then((response) => {
			// console.log('res', response.data.mediaId)
			this.riveUrl = response.data.mediaId;
			this.initRive();
		});
		this.canvasId = `rive-element-canvas-${this.id}`;
	},
	methods:{
		 initRive() {
			this.$nextTick(() => {
			const canvas = document.getElementById(this.canvasId);
			if (!canvas) {
				console.error('Canvas not found:', this.canvasId);
				return;
			}

			const riveElementAnimation = new rive.Rive({
				src: this.riveUrl,
				canvas: canvas,
				layout: new Layout({
					fit: Fit.Cover,
					alignment: Alignment.Center,
				}),
				onLoad: () => {
				riveElementAnimation.resizeDrawingSurfaceToCanvas();
				},
			});
			riveElementAnimation.play();

			window.addEventListener('resize', () => {
				riveElementAnimation.resizeDrawingSurfaceToCanvas();
			})

		});
			
		
		}
	}
};
</script>
